import { render, staticRenderFns } from "./duo_work_item_to_mr_action.vue.js?vue&type=template&id=68445214!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./duo_work_item_to_mr_action.vue?vue&type=template&id=68445214"
import script from "./duo_work_item_to_mr_action.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./duo_work_item_to_mr_action.vue?vue&type=script&lang=js"
export * from "./duo_work_item_to_mr_action.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./duo_work_item_to_mr_action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports